<app-page>
    <app-title>
        {{ 'support' | translate }}
    </app-title>
     <app-table-layout [columns]="deviceService.ifMobile(1).orElse(3)" [items]="3">
        <div #layout>
            <mat-card width="100%">
                <mat-card-header>
                    <table align="center" width="100%">
                        <tr>
                            <td align="center">
                                <mat-card-title>{{ 'support_video_menu_availability_title' | translate }}</mat-card-title>
                            </td>
                        </tr>
                        <tr *ngIf="!isSpanish()" >
                            <td align="center" class="iframe-container">
                                <iframe src="https://www.youtube.com/embed/vOYQiJVddtU"></iframe>
                            </td>
                        </tr>
                        <tr *ngIf="isSpanish()" >
                            <td align="center" class="iframe-container" >
                                <iframe src="https://www.youtube.com/embed/vOYQiJVddtU"></iframe>
                            </td>
                        </tr>
                    </table>
                </mat-card-header>
                <mat-card-content>
                    <br>
                    {{ 'support_video_menu_availability_description' | translate }}
                </mat-card-content>
            </mat-card>
        </div>
        <div #layout>
            <mat-card width="100%">
                <mat-card-header>
                    <table align="center" width="100%">
                        <tr>
                            <td align="center">
                                <mat-card-title>{{ 'support_video_sales_summary_title' | translate }}</mat-card-title>
                            </td>
                        </tr>
                        <tr *ngIf="!isSpanish()" >
                            <td align="center" class="iframe-container">
                                <iframe src="https://www.youtube.com/embed/M11G8c4LIQs"></iframe>
                            </td>
                        </tr>
                        <tr *ngIf="isSpanish()" >
                            <td align="center" class="iframe-container" >
                                <iframe src="https://www.youtube.com/embed/M11G8c4LIQs"></iframe>
                            </td>
                        </tr>
                    </table>
                </mat-card-header>
                <mat-card-content>
                    <br>
                    {{ 'support_video_sales_summary_description' | translate }}
                </mat-card-content>
            </mat-card>
        </div>
        <div #layout>
            <mat-card width="100%">
                <mat-card-header>
                    <table align="center" width="100%">
                        <tr>
                            <td align="center">
                                <mat-card-title>{{ 'support_video_business_setup_title' | translate }}</mat-card-title>
                            </td>
                        </tr>
                        <tr *ngIf="!isSpanish()" >
                            <td align="center" class="iframe-container">
                                <iframe src="https://www.youtube.com/embed/qZRJYwt90I4"></iframe>
                            </td>
                        </tr>
                        <tr *ngIf="isSpanish()" >
                            <td align="center" class="iframe-container" >
                                <iframe src="https://www.youtube.com/embed/qZRJYwt90I4"></iframe>
                            </td>
                        </tr>
                    </table>
                </mat-card-header>
                <mat-card-content>
                    <br>
                    {{ 'support_video_business_setup_description' | translate }}
                </mat-card-content>
            </mat-card>
        </div>
    </app-table-layout>
</app-page>
